export default __webpack_public_path__ + "static/women-bodymap-posterior-4da405b2ec40f26bf6c196143288e069.webp";